import {
  Setting,
  PaginatedResponse,
  QueryResponse,
  UpdateListSettingItemDTO
} from '@/types';
import gql from 'graphql-tag';
import { ApiService } from '@/services';
import { UtilService } from '@/services';

export class SettingService extends ApiService {
  public async getSettings(): Promise<Setting[]> {
    const query = gql`
      query settings {
        settings {
          id
          key
          group
          namespace
          value
          description
          editable
          encrypted
          type
        }
      }
    `;
    let settings: Setting[] = await this.query<Setting[]>(
      { query },
      'settings'
    );
    settings = settings.map((s: Setting) => {
      return {
        ...s,
        value: JSON.parse(s.value)
      };
    });
    return settings;
  }

  public async getSetting(key: string): Promise<Setting> {
    const query = gql`
      query public_setting($key: String!) {
        public_setting(key: $key) {
          id
          key
          group
          namespace
          value
          description
          editable
          encrypted
          type
          updated_at
          created_at
        }
      }
    `;
    let setting: Setting = await this.pubQuery<Setting>(
      { query, variables: { key } },
      'public_setting'
    );
    return setting;
  }

  public async mutateSetting(setting: Setting): Promise<Setting> {
    const mutation = gql`
      mutation mutateSetting($id: ID!, $value: String!) {
        mutate_setting(id: $id, value: $value) {
          id
          key
          group
          namespace
          value
          description
          editable
          encrypted
          type
        }
      }
    `;
    return await this.mutate(
      {
        mutation,
        variables: {
          id: setting.id,
          value: JSON.stringify(setting.value)
        }
      },
      'mutate_setting'
    );
  }

  public async addListSettingItem(
    dto: UpdateListSettingItemDTO
  ): Promise<Response> {
    const mutation = gql`
      mutation addListSettingItem($id: ID!, $item: String!) {
        add_list_setting_item(id: $id, item: $item) {
          status
          message
        }
      }
    `;
    return await this.mutate(
      {
        mutation,
        variables: dto
      },
      'add_list_setting_item'
    );
  }

  public async removeListSettingItem(
    dto: UpdateListSettingItemDTO
  ): Promise<Response> {
    const mutation = gql`
      mutation removeListSettingItem($id: ID!, $item: String!) {
        remove_list_setting_item(id: $id, item: $item) {
          status
          message
        }
      }
    `;
    return await this.mutate(
      {
        mutation,
        variables: dto
      },
      'remove_list_setting_item'
    );
  }
}

export const settingSvc: SettingService = new SettingService();
